import script from "./BaseSheet.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseSheet.vue?vue&type=script&setup=true&lang=ts"

import "./BaseSheet.vue?vue&type=style&index=0&id=0c476897&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c476897"]])

export default __exports__